<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF LAW</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">legal Studies</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">LL.B</td>
                            <td class="time">Master of Legislative Law</td>
                        </tr>
                        <tr>
                            <td class="time">BA. LL.B</td>
                            <td class="time"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Law</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">LL.B </b>
                    – The three-year Bachelor of Legislative Law (LL.B.) program at ARNI School of Law consists of six
                    semesters of coursework. Labor Law, Family Law, Crime, Women and Law, Law of Evidence,
                    Jurisprudence, Human Rights and International Law, and Practical Training in Legal Aid are among the
                    topics covered in the LLB curriculum. The course covers topics such as civil procedure code,
                    administrative law, labor law, crime, legal writing, etc.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">LLB </b>: Semester 1st</p>
                <ul>
                    <li> Law of Contract I</li>
                    <li> Family Law I</li>
                    <li> Constitutional Law I</li>
                    <li> Law of Crimes</li>
                    <li> Elective (RTI and PIL)</li>
                    <li> Elective (Women and Law)</li>
                    <li> Elective (Criminology and Penology)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">LLB </b>: Semester 2nd</p>
                <ul>
                    <li> Law of Contract II</li>
                    <li> Family Law II</li>
                    <li> Constitutional Law II</li>
                    <li> Professional Ethics & Bar-Bench Relations for Lawyers</li>
                    <li> Elective (Healthcare Law)</li>
                    <li> Elective (Law and Media)</li>
                    <li> Elective (Election Law)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">LLB </b>: Semester 3rd</p>
                <ul>
                    <li> Legal Language</li>
                    <li> Law of Evidence</li>
                    <li> Human Rights and International Law</li>
                    <li> Conciliation, Arbitration, and Alternate Dispute Resolution System</li>
                    <li> Elective (Comparative Laws)</li>
                    <li> Elective (Conflict Laws)</li>
                    <li> Elective (Environmental Law)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">LLB </b>: Semester 4th</p>
                <ul>
                    <li> International Economic Law</li>
                    <li> Company Law</li>
                    <li> Taxation Law</li>
                    <li> Administrative Law</li>
                    <li> Pleading, Drafting, and Conveyancing</li>
                    <li> Jurisprudence</li>
                    <li> Motor Vehicle Act, Tort and Consumer Protection Act</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">LLB </b>: Semester 5th</p>
                <ul>
                    <li> Banking Laws</li>
                    <li> Property Laws</li>
                    <li> IPR</li>
                    <li> Code of Criminal Procedure Limitation Act</li>
                    <li> Legal Writing</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">LLB </b>: Semester 6th</p>
                <ul>
                    <li> Labor Laws</li>
                    <li> Land Laws</li>
                    <li> Criminal Procedure, Juvenile Justice & Probation Offenders Act</li>
                    <li> Practical Training and Moot Courts</li>
                    <li> Practical Training – Drafting</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">BA. LL.B </b> –
                    ARNI School of Law's B.A. LL.B program offers a five-year, integrated course in law, justice, and
                    governance, focusing on constitutional, criminal, corporate, and legal research, practical training,
                    and internships. With a focus on practical training, moot courts, and internships, this program
                    prepares students for a dynamic legal career in advocacy, judiciary, corporate law, and public
                    service.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BA. LL.B
                </b>: Semester 1
                </p>
                <ul>
                    <li> Communication Skills and Legal English</li>
                    <li> History – I</li>
                    <li> Economics-I</li>
                    <li> Political Science-I</li>
                    <li> Sociology-I</li>
                    <li> Legal Method</li>
                    <li> Introduction to Law</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BA. LL.B
                </b>: Semester 2
                </p>
                <ul>
                    <li> History – II</li>
                    <li> Economics-II</li>
                    <li> Political Science-II</li>
                    <li> Sociology-II</li>
                    <li> Consumer Protection & Law of Torts</li>
                    <li> Law of Contract-I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BA. LL.B
                </b>: Semester 3
                </p>
                <ul>
                    <li> Constitutional Law-I</li>
                    <li> Political Science-III</li>
                    <li> Family Law-I</li>
                    <li> Law of Crimes-I</li>
                    <li> Sociology-III</li>
                    <li> Comprehensive Viva</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BA. LL.B
                </b>: Semester 4 </p>
                <ul>
                    <li> Constitutional Law-I</li>
                    <li> Constitutional Law-II</li>
                    <li> Economics-III</li>
                    <li> Family Law-II</li>
                    <li> Law of Crimes-II</li>
                    <li> Administrative Law</li>
                    <li> Comprehensive Viva</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BA. LL.B
                </b>: Semester 5 </p>
                <ul>
                    <li> Law of Evidence</li>
                    <li> Alternative Dispute Resolution (ADR)</li>
                    <li> Environmental Law</li>
                    <li> Labour Law-I</li>
                    <li> Criminal Law – I</li>
                    <li> Comprehensive Viva</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BA. LL.B
                </b>: Semester 6 </p>
                <ul>
                    <li> International Law</li>
                    <li> Jurisprudence</li>
                    <li> Investment and Competition Law</li>
                    <li> Property Law</li>
                    <li> Code of Criminal Procedure</li>
                    <li> Comprehensive Viva and Internship</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BA. LL.B
                </b>: Semester 7 </p>
                <ul>
                    <li> Human Rights</li>
                    <li> Taxa Law</li>
                    <li> Labour Law-II</li>
                    <li> Seminar Paper-I</li>
                    <li> Pleading, Drafting, and Conveyancing</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BA. LL.B
                </b>: Semester 8 </p>
                <ul>
                    <li> Interpretation of Statutes</li>
                    <li> Intellectual Property Rights</li>
                    <li> International Trade Law</li>
                    <li> Professional Ethics</li>
                    <li> Optional Paper – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BA. LL.B
                </b>: Semester 9 </p>
                <ul>
                    <li> Real Estate & Land Law</li>
                    <li> Court Crafts & Legal Ethics</li>
                    <li> Private International Law</li>
                    <li> Acquisition and Competition Laws</li>
                    <li> Optional Paper - II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">BA. LL.B
                </b>: Semester 10 </p>
                <ul>
                    <li> Moot Courts Internships</li>
                    <li> Optional Paper – III</li>
                    <li> Optional Paper -IV</li>
                    <li> Dissertation</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Legislative Law </b> –
                    The ARNI School of Law's Master of Legislative Law (LLM) program is a two-year postgraduate degree
                    offering advanced legal education in various areas. The program consists of four semesters, covering
                    foundational legal principles and elective courses, aiming to provide students with a comprehensive
                    understanding of the legal system.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">LLM
                </b>: Semester 1</p>
                <ul>
                    <li> Organizations and Human Rights</li>
                    <li> Social Responsibility in Corporate Management</li>
                    <li> Intellectual and Industrial Property Laws</li>
                    <li> Wage Law and Comparative Labour</li>
                    <li> Law of Women and Child Rights</li>
                    <li> Legal Research Methodology</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">LLM
                </b>: Semester 2</p>
                <ul>
                    <li> Comparative Law of Marriage, Divorce and Civil Code</li>
                    <li> Law of Corporate Finance and Securities Regulation</li>
                    <li> Cyber and Information Technology Law</li>
                    <li> Constitutional Law</li>
                    <li> Elective I (Specializations)</li>
                    <li> Legal Writing and Advocacy</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">LLM
                </b>: Semester 3</p>
                <ul>
                    <li> Competition and Consumer Protection Law</li>
                    <li> Tax Policies and Tax Reforms</li>
                    <li> Laws of Inheritance and Succession</li>
                    <li> Criminal Law and Procedure</li>
                    <li> Elective II (Specializations)</li>
                    <li> Interpretation and Drafting of Treaties and Legislation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">LLM
                </b>: Semester 4</p>
                <ul>
                    <li> Elective III (Specializations)</li>
                    <li> Elective IV (Specializations)</li>
                    <li> Internship and Practical Training</li>
                    <li> Dissertation/ Thesis</li>
                </ul>
            </div>

        </div>

    </div>
</section>
